import { render } from "./resources.vue?vue&type=template&id=4a609f01&scoped=true"
import script from "./resources.vue?vue&type=script&lang=js"
export * from "./resources.vue?vue&type=script&lang=js"

import "./resources.vue?vue&type=style&index=0&id=4a609f01&scoped=true&lang=css"
import "./resources.vue?vue&type=style&index=1&id=4a609f01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a609f01"]])

export default __exports__